import { useParams } from 'react-router-dom';

import type { CardId } from '@vlabs/api/point-api/model';
import { IncorrectCardExternalIdError } from '../errors';

export function useCardIdFromLocation(): CardId {
  const { externalId: cardId } = useParams<{ externalId: string }>();

  if (!cardId) {
    throw new IncorrectCardExternalIdError();
  }

  return cardId;
}
